
export const isInactiveAndNoMembers = (status, members) => {
    return !status && members < 1;
}

export const isActiveOrEmpty = (status, members) => {
    return status || members < 1;
}